import { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import SimpleSelect from "../../components/selects/simpleSelect";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { indicatorsType, months } from "../../constants/selectData";
import TaskIndicatorCard from "../../components/taskIndicatorCard";
import HighchartsComponent from "../../components/highchartsComponent";
import { indicatorsExecutedvsProjected } from "../../components/highchartsComponent/charts/indicatorsExecutedvsProjected";
import { indicatorOfUnexecutedTasks } from "../../components/highchartsComponent/charts/indicatorOfUnexecutedTasks";
import SimpleTable from "../../components/tables/simpleTable";
import { indicatorTableColumns } from "./tableColumns";
import { icons } from "../../constants";
import { indicatorsExecutedvsProjectedTooltip } from "./tooltipData";
import { StyledTooltip } from "../../components/toolltipComponent";
import { computeWeeksOfMonth } from "../../services/dateService";
import {
  getindicatorsExecutedvsProjectedData,
  getExecutedVsProjectedDetailData,
  getAssignableUsersData,
  getTaskYearsSelect,
  getPlannedNotExecutedIndicatorsFn,
  getPlannedNotExecutedDataFn,
  getindicatorsExecutedvsNoProjectedData,
  getExecutedVsNoProjectedDetailData,
  getIndicatorTaskDeletedChartData,
  getIndicatorTaskDeletedDetailData,
  getIndicatorUnplannedExecutedData,
  getIndicatorUnplannedExecutedDetailsData
} from "./getIndicatorData";
import {
  indicatorsExecutedvsProjectedCards,
  indicatorsPlannedNotExcecutedCards,
  indicatorsExecutedvsNoProjectedCards,
  indicatorsTaskDeletedCards,
  unplannedExecutedDataCards
} from "./indicatorCards";
import AddTaskModal from "./addTaskModal";
import TaskDayCommentsModal from "./taskDayCommentsModal";
import { getCurrentMonth } from "../../utils/dateUtils";
import { indicatorType_ENUM } from "../../constants/enums";
import { indicatorsExecutedvsNoProjected } from "../../components/highchartsComponent/charts/indicatorsExecutedvsNoProjected";
import indicatorTaskDeleted from "../../components/highchartsComponent/charts/indicatorTaskDeleted";
import { indicatorUnplannedExecuted } from "../../components/highchartsComponent/charts/indicatorUnplannedExecuted";

const schema = {};

export default function IndicatorsPanel({ type }) {
  const title =
    type === "indicadores_gerenciales"
      ? "Indicadores gerenciales"
      : "Indicadores";

  const getTitle = () => {
    switch (selectedIndicatorRaw) {
      case indicatorType_ENUM.EXCECUTED_VS_PROJECTED:
        return "Actividades Ejecutadas vs Planificadas";
      case indicatorType_ENUM.PLANNED_NOT_EXCECUTED:
        return "Actividades planificadas NO ejecutadas";
      case indicatorType_ENUM.EXCECUTED_NOT_PROJECTED:
        return "Actividades Ejecutadas vs No Planificadas";
      case indicatorType_ENUM.UNPLANNED_EXECUTED:
        return "Cumplimiento de Actividades Delegadas";
      case indicatorType_ENUM.TASK_DELETED:
        return "Actividades eliminadas";
      default:
        return "Indicadores";
    }
  };

  const {
    control,
    watch,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      year: "",
      month: getCurrentMonth(),
      week: ""
    }
  });

  const selectedIndicatorRaw = watch("indicatorType");
  const selectedYear = watch("year");
  const selectedMonth = watch("month");
  const weekRange = watch("week");

  const [selectedTask, setSelectedTask] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [weekOptions, setWeekOptions] = useState([]);
  const [catsData, setCatsData] = useState({ A: "-", B: "-", C: "-", D: "-" });
  const [summary, setSummary] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openComments, setOpenComments] = useState(false);
  const [assignableList, setAssignableList] = useState([]);
  const [years, setYears] = useState([]);
  const [detailPage, setDetailPage] = useState(1);
  const [detailTotal, setDetailTotal] = useState(0);
  const ROWS_PER_PAGE = 10;
  const [chartData, setChartData] = useState({
    cats: ["A", "B", "C", "D"],
    projected: {
      proy_asignadas: [0, 0, 0, 0],
      proy_delegadas: [0, 0, 0, 0],
      proy_continuas: [0, 0, 0, 0]
    },
    executed: {
      eje_asignadas: [0, 0, 0, 0],
      eje_delegadas: [0, 0, 0, 0],
      eje_continuas: [0, 0, 0, 0]
    }
  });
  const [chartPlannedNotExcecuted, setChartPlannedNotExcecuted] = useState({});

  const getChartOptions = () => {
    if (selectedIndicatorRaw === indicatorType_ENUM.EXCECUTED_VS_PROJECTED) {
      return indicatorsExecutedvsProjected(chartData);
    }
    if (selectedIndicatorRaw == indicatorType_ENUM.PLANNED_NOT_EXCECUTED) {
      return indicatorOfUnexecutedTasks(chartPlannedNotExcecuted);
    }
    if (selectedIndicatorRaw === indicatorType_ENUM.EXCECUTED_NOT_PROJECTED) {
      return indicatorsExecutedvsNoProjected(chartData);
    }
    if (selectedIndicatorRaw === indicatorType_ENUM.UNPLANNED_EXECUTED) {
      return indicatorUnplannedExecuted(chartData);
    }
    if (selectedIndicatorRaw === indicatorType_ENUM.TASK_DELETED) {
      return indicatorTaskDeleted(chartData);
    }
    return indicatorsExecutedvsProjected(chartData);
  };

  const getTooltip = () => {
    switch (selectedIndicatorRaw) {
      case indicatorType_ENUM.EXCECUTED_VS_PROJECTED:
      case indicatorType_ENUM.PLANNED_NOT_EXCECUTED:
      case indicatorType_ENUM.EXCECUTED_NOT_PROJECTED:
      case indicatorType_ENUM.UNPLANNED_EXECUTED:
      case indicatorType_ENUM.TASK_DELETED:
        return indicatorsExecutedvsProjectedTooltip();
      default:
        return indicatorsExecutedvsProjectedTooltip();
    }
  };

  const handlePageChange = (newPage) => {
    getChartDataDetail(newPage);
  };

  const getIndicatorCards = () => {
    switch (selectedIndicatorRaw) {
      case indicatorType_ENUM.EXCECUTED_VS_PROJECTED:
        return indicatorsExecutedvsProjectedCards(summary);
      case indicatorType_ENUM.PLANNED_NOT_EXCECUTED:
        return indicatorsPlannedNotExcecutedCards(summary);
      case indicatorType_ENUM.EXCECUTED_NOT_PROJECTED:
        return indicatorsExecutedvsNoProjectedCards(summary);
      case indicatorType_ENUM.TASK_DELETED:
        return indicatorsTaskDeletedCards(summary);
      case indicatorType_ENUM.UNPLANNED_EXECUTED:
        return unplannedExecutedDataCards(summary);

      default:
        return indicatorsExecutedvsProjectedCards(chartData);
    }
  };

  const getChartDataDetail = (page = 1) => {
    if (!selectedYear || !selectedMonth) return;

    switch (selectedIndicatorRaw) {
      case indicatorType_ENUM.EXCECUTED_VS_PROJECTED:
        getExecutedVsProjectedDetailData(
          selectedYear,
          selectedMonth,
          weekRange,
          setTableData,
          setDetailTotal,
          setDetailPage,
          page,
          ROWS_PER_PAGE
        );
        break;
      case indicatorType_ENUM.EXCECUTED_NOT_PROJECTED:
        getExecutedVsNoProjectedDetailData(
          selectedYear,
          selectedMonth,
          weekRange,
          setTableData,
          setDetailTotal,
          setDetailPage,
          page,
          ROWS_PER_PAGE
        );
        break;
      case indicatorType_ENUM.PLANNED_NOT_EXCECUTED:
        getPlannedNotExecutedDataFn(
          selectedYear,
          selectedMonth,
          weekRange,
          setTableData,
          setDetailPage,
          setDetailTotal,
          page,
          ROWS_PER_PAGE
        );
        break;
      case indicatorType_ENUM.UNPLANNED_EXECUTED:
        getIndicatorUnplannedExecutedDetailsData(
          selectedYear,
          selectedMonth,
          weekRange,
          setTableData,
          setDetailPage,
          setDetailTotal,
          detailPage,
          ROWS_PER_PAGE
        );
        break;
      case indicatorType_ENUM.TASK_DELETED:
        getIndicatorTaskDeletedDetailData(
          selectedYear,
          selectedMonth,
          weekRange,
          setTableData,
          setDetailPage,
          setDetailTotal,
          detailPage,
          ROWS_PER_PAGE
        );
        break;

      default:
        return;
    }
  };

  const getChartData = () => {
    if (!selectedYear || !selectedMonth) return;

    switch (selectedIndicatorRaw) {
      case indicatorType_ENUM.EXCECUTED_VS_PROJECTED:
        getindicatorsExecutedvsProjectedData(
          selectedYear,
          selectedMonth,
          weekRange,
          setChartData,
          setCatsData,
          setSummary
        );
        getExecutedVsProjectedDetailData(
          selectedYear,
          selectedMonth,
          weekRange,
          setTableData,
          setDetailTotal,
          setDetailPage,
          detailPage,
          ROWS_PER_PAGE
        );
        break;

      case indicatorType_ENUM.PLANNED_NOT_EXCECUTED:
        getPlannedNotExecutedIndicatorsFn(
          selectedYear,
          selectedMonth,
          weekRange,
          setCatsData,
          setSummary,
          setChartPlannedNotExcecuted
        );
        getPlannedNotExecutedDataFn(
          selectedYear,
          selectedMonth,
          weekRange,
          setTableData,
          setDetailPage,
          setDetailTotal,
          detailPage,
          ROWS_PER_PAGE
        );
        break;

      case indicatorType_ENUM.EXCECUTED_NOT_PROJECTED:
        getindicatorsExecutedvsNoProjectedData(
          selectedYear,
          selectedMonth,
          weekRange,
          setChartData,
          setCatsData,
          setSummary
        );
        getExecutedVsNoProjectedDetailData(
          selectedYear,
          selectedMonth,
          weekRange,
          setTableData,
          setDetailTotal,
          setDetailPage,
          detailPage,
          ROWS_PER_PAGE
        );
        break;
      case indicatorType_ENUM.UNPLANNED_EXECUTED:
        getIndicatorUnplannedExecutedData(
          selectedYear,
          selectedMonth,
          weekRange,
          setChartData,
          setSummary,
          setCatsData
        );
        getIndicatorUnplannedExecutedDetailsData(
          selectedYear,
          selectedMonth,
          weekRange,
          setTableData,
          setDetailTotal,
          setDetailPage,
          detailPage,
          ROWS_PER_PAGE
        );
        break;

      case indicatorType_ENUM.TASK_DELETED:
        getIndicatorTaskDeletedChartData(
          selectedYear,
          selectedMonth,
          weekRange,
          setChartData,
          setCatsData,
          setSummary
        );
        getIndicatorTaskDeletedDetailData(
          selectedYear,
          selectedMonth,
          weekRange,
          setTableData,
          setDetailTotal,
          setDetailPage,
          detailPage,
          ROWS_PER_PAGE
        );
        break;

      default:
        return;
    }
  };

  useEffect(() => {
    if (!selectedYear || !selectedMonth) {
      setWeekOptions([]);
      setDetailPage(1);
      setDetailTotal(0);
      setValue("week", "");
      return;
    }
    setDetailPage(1);
    setDetailTotal(0);
    const weeks = computeWeeksOfMonth(selectedYear, selectedMonth);
    setWeekOptions([
      { label: "\u00A0", value: "" }, // &nbsp;
      ...weeks
    ]);

    setValue("week", "");
  }, [selectedYear, selectedMonth, setValue]);

  useEffect(() => {
    setDetailPage(1)
    getChartData();
  }, [selectedYear, selectedMonth, weekRange, selectedIndicatorRaw]);

  useEffect(() => {
    getAssignableUsersData(0, true, setAssignableList);
    getTaskYearsSelect(setYears, setValue, getChartData);
  }, [setValue]);

  useEffect(() => {
    setValue("indicatorType", 1);
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "white",
        border: "1px solid #ddd",
        borderRadius: 2,
        p: 3,
        mb: 3,
        minWidth: 0
      }}
    >
      <Box>
        <Typography variant="h6" color="#4444B2" fontWeight="bold">
          {title}
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <p className="blueLabelForm">Selecciona tipo de Indicador:</p>
          <SimpleSelect
            margin={"0 0 15px 0"}
            name="indicatorType"
            control={control}
            options={indicatorsType}
          />
        </Grid>
      </Grid>

      <div className="box-border p-15">
        <Typography mb={2} variant="h6" color="#4444B2" fontWeight="bold">
          {getTitle()}
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <p className="blueLabelForm">Año:</p>
            <SimpleSelect
              margin={"0"}
              name="year"
              control={control}
              options={years}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <p className="blueLabelForm">Mes:</p>
            <SimpleSelect
              margin={"0"}
              name="month"
              control={control}
              options={months}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <p className="blueLabelForm">Semana:</p>
            <SimpleSelect
              margin={"0"}
              name="week"
              control={control}
              options={weekOptions}
              disabled={weekOptions.length === 0}
            />
          </Grid>
        </Grid>

        <div className="VContainer mt-10 ">
          <div className="p-15 mt-10 pr-0">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={9} className="box-border p-15">
                <HighchartsComponent options={getChartOptions()} />
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className="VContainer">
                  <div className="j-center bm-20">
                    <StyledTooltip title={getTooltip()} placement="top">
                      <img
                        className="btn-icon-25 pointer mb-20"
                        src={icons.info_blue}
                        alt="icon"
                      />
                    </StyledTooltip>
                  </div>
                  <div>{getIndicatorCards()}</div>
                </div>
              </Grid>
            </Grid>
          </div>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <TaskIndicatorCard
                title="Clasificación A"
                value={catsData.A}
                color="#F9C7C5"
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TaskIndicatorCard
                title="Clasificación B"
                value={catsData.B}
                color="#FFE0B3"
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TaskIndicatorCard
                title="Clasificación C"
                value={catsData.C}
                color="#D4DBFF"
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TaskIndicatorCard
                title="Clasificación D"
                value={catsData.D}
                color="#C9E8C7"
              />
            </Grid>
          </Grid>
        </div>
      </div>

      <div className="vm-10">
        <Typography variant="h6" color="#4444B2" fontWeight="bold">
          Detalle
        </Typography>
      </div>

      <SimpleTable
        columns={indicatorTableColumns}
        data={tableData}
        isPaginated={true}
        onPageChange={handlePageChange}
        serverPagination={true}
        totalRecords={detailTotal}
        rowsPerPage={ROWS_PER_PAGE}
        currentPage={detailPage}
        emptyMessage={
          "No hay actividades justificadas para los filtros seleccionados"
        }
        buttons={[
          {
            type: "icon",
            icon: icons.expediente_blue,
            onClick: (data) => {
              setOpenComments(true);
              setSelectedTask(data);
            }
          },
          {
            type: "icon",
            icon: icons.eye,
            onClick: (data) => {
              setOpenModal(true);
              setSelectedTask(data);
            }
          }
        ]}
      />

      <AddTaskModal
        open={openModal}
        handleClose={() => {
          setOpenModal(false);
          setSelectedTask(null);
        }}
        onSubmit={() => {}}
        initialData={selectedTask}
        assignableList={assignableList}
        disabled={true}
      />

      <TaskDayCommentsModal
        open={openComments}
        onClose={() => setOpenComments(false)}
        task={selectedTask}
        defaultDate={new Date()}
      />
    </Box>
  );
}
